import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import Blog from "../blog/blog";
import Clients from "./components/clients/clients";
import ContactBanner from "./components/contactBanner/contactbanner";
import Hero from "./components/hero";
import Products from "./components/products/products";
import ProductsBanner from "./components/productsBanner/productsBanner";
import Reviews from "./components/reviews/reviews";
import TurnoverBanner from "./components/turnoverBanner/turnoverBanner";
import WhoServices from "./components/whoServices/whoServices";
import Why from "./components/why/why";

const Landing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="landinf">
      <Hero />
      <ProductsBanner />
      <WhoServices />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <TurnoverBanner />
      <Why />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Products />
      <br />
      <br />
      <br />
      <br />
      <Clients />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Reviews />
      <br />
      <br />
      <br />
      <br />
      <ContactBanner />
      <Blog />
    </Box>
  );
};

export default Landing;
